document.addEventListener("DOMContentLoaded", function () {
  let isOpen = false;
  const openMiniCartButton = document.querySelectorAll(".js-open-mini-cart");
  const addToCartButton = document.querySelector("#js-button-add-to-cart");
  const buyItNowButton = document.querySelector("#js-buy-it-now");
  const miniCart = document.querySelector("#mini-cart");
  const productsContainer = miniCart.querySelector(".mini-cart__products");
  const miniCartCount = miniCart.querySelector(".js-mini-cart-count");
  const headerCartCount = document.querySelector(".js-header-cart-count");
  const miniCartTotal = miniCart.querySelector(".js-mini-cart-total");
  const miniCartClose = document.querySelectorAll(".js-close-mini-cart");
  const miniCartSuccess = miniCart.querySelector(".hp-message--success");
  const miniCartEmpty = miniCart.querySelector(".mini-cart__empty");
  const shadow = document.querySelector(".fullpage-shadow");

  const close = () => {
    isOpen = false;
    miniCart.classList.remove("open");
    shadow.classList.remove("open");
  };

  const open = () => {
    isOpen = true;
    miniCart.classList.add("open");
    shadow.classList.add("open");
  };

  miniCartClose.forEach((close) => {
    close.addEventListener("click", function () {
      isOpen = false;
      miniCart.classList.remove("open");
      shadow.classList.remove("open");
    });
  });

  openMiniCartButton.forEach((button) => {
    button.addEventListener("click", function () {
      fetchCart();
    });
  });

  document.addEventListener("keyup", (event) => {
    if (isOpen && event.key === "Escape") {
      close();
    }
  });

  window.addEventListener("click", (event) => {
    if (isOpen && !event.target.closest(".mini-cart")) {
      close();
    }
  });

  const getPrice = (price) => {
    return `$${parseFloat(price * 0.01).toFixed(2)}`;
  };

  const updateCart = (data) => {
    productsContainer.innerHTML = "";
    miniCartTotal.textContent = getPrice(data.total_price);
    miniCartCount.textContent = data.item_count;
    headerCartCount.textContent = data.item_count;
    headerCartCount.setAttribute("data-count", data.item_count);
    if (data.items.length === 0) {
      miniCart.classList.add("is-empty");
    } else {
      miniCart.classList.remove("is-empty");
      data.items.forEach((item) => {
        createItem(item);
      });
    }
  };

  window.updateQuantity = (id, quantity) => {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: String(id),
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        miniCartSuccess.classList.add("hidden");
        updateCart(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const createItem = (item) => {
    const itemTemplate = `
      <div data-id="${item.id}" class="item-row item-row--mobile">
        <div class="cart-item">
          <div class="cart-item__image-wrapper">
            <a href="${item.url}">
              <img
                src="${item.featured_image.url}"
                class="cart-item__image"
                alt="${item.featured_image.alt}"
                loading="lazy"
                width="150"
              >
            </a>
          </div>
          <div class="cart-item__details">
            <a href="${item.url}">
              <div class="cart-item__name hp-book--regular">${
                item.product_title
              }</div>
            </a>

            <span class="item-total  hp-book--regular">${getPrice(
              item.final_line_price
            )}</span>
            <div class="cart-item__variant hp-labels--regular">
              ${item.options_with_values
                .map((option) => option.value)
                .join(" | ")}
            </div>
            <div class="cart-item__actions">
              <div class="cart__item-quantity">
                <button class="js-decrease-quantity hp-link" data-id="${
                  item.id
                }" onClick="updateQuantity(${item.id}, ${item.quantity - 1})">
                  <span class="svg-wrapper">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.16797 10H15.8346" stroke="#2F2F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                  </span>
                </button>
                <input
                  class="item-quantity hp-cta--small"
                  readonly
                  value="${item.quantity}"
                  min="1"
                >
                <button class="js-increase-quantity hp-link" data-id="${
                  item.id
                }" onClick="updateQuantity(${item.id}, ${item.quantity + 1})">
                  <span class="svg-wrapper">
                   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 4.16669V15.8334" stroke="#2F2F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.16797 10H15.8346" stroke="#2F2F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                  </span>
                </button>
              </div>
              <span class="js-remove cart__item-remove hp-cta--small" data-id="${
                item.id
              }" onClick="updateQuantity(${item.id}, 0)">Remove</span>
            </div>
          </div>
        </div>
      </div>
    `;

    productsContainer.insertAdjacentHTML("beforeend", itemTemplate);
  };

  const udpateMiniCartContent = (data) => {
    productsContainer.innerHTML = "";
    miniCartTotal.textContent = getPrice(data.total_price);
    miniCartCount.textContent = data.item_count;
    headerCartCount.textContent = data.item_count;
    headerCartCount.setAttribute("data-count", data.item_count);
    if (data.items.length === 0) {
      miniCart.classList.add("is-empty");
    } else {
      miniCart.classList.remove("is-empty");
      data.items.forEach((item) => {
        createItem(item);
      });
    }
    open();
  };

  const fetchCart = () => {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        udpateMiniCartContent(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  // Initialize header cart count on page load without opening the mini cart
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      updateCart(data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });

  if (addToCartButton) {
    addToCartButton.addEventListener("click", function (e) {
      const quantityInput = document.querySelector("#product-quantity");
      const variantIdInput = document.querySelector(".product-variant-id");
      const quantity = quantityInput.value;
      const variantId = variantIdInput.value;

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              quantity: quantity,
              id: variantId,
            },
          ],
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          miniCartSuccess.classList.remove("hidden");
          fetchCart();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  }
  if (buyItNowButton) {
    buyItNowButton.addEventListener("click", () => {
      const quantityInput = document.querySelector("#product-quantity");
      const variantIdInput = document.querySelector(".product-variant-id");
      const quantity = quantityInput.value;
      const variantId = variantIdInput.value;

      const host = window.location.hostname;
      const cartUrl = `//${host}/cart/${variantId}:${quantity}`;

      window.location.href = cartUrl;
    });
  }
});
